// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyDw6KwbA349MqGIoxvwCBWM6r0MjrJ8LPs",
    authDomain: "terminoo-d5a37.firebaseapp.com",
    databaseURL: "https://terminoo-d5a37.firebaseio.com",
    projectId: "terminoo-d5a37",
    storageBucket: "terminoo-d5a37.appspot.com",
    messagingSenderId: "169019105233",
    appId: "1:169019105233:web:a9634282caffc98b7e4af0"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
